import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry,
    formatDate,
    ExcelDateToDateString
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {cloneDeep} from "lodash";


//Set the type of the props data
export interface Props {
    excelData: any;
    currentDB: string;
}

interface premRate {
    premRate_Key: number | null,
    premRate_ID: string | null,
    premRate_Category: string | null,
    premRate_Basis: string | null,
    description: string | null,
    effective_Date: string | null,
    term_Date: string | null,
    group_ID: string | null,
    division_ID: string | null,
    plan_ID: string | null,
    plan_Type: string | null,
    tier: string | null,
    premRatePayees: any[],
    rate: number | null,
    rate_Type: string | null,
    rate_Variable1: number | null,
    rate_Variable2: number | null,
    rate_Variable3: number | null,
    vbasoftware_database: string | null,
    vbapi_Token: string | null,
    premRate_Type: string | null,
}

function BulkPremRateImporter({excelData, currentDB}: Props) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [currentPremRate, setCurrentPremRate] = React.useState<premRate>({premRate_Key: 0, premRate_ID: "", premRate_Category: "",
        premRate_Basis: "", description: "", effective_Date: "", term_Date: "", group_ID: "", division_ID: "", plan_ID: "", plan_Type: "",
        tier: "", premRatePayees: [], rate_Type: "", rate: 0, rate_Variable1: 0, rate_Variable2: 0, rate_Variable3: 0, premRate_Type: "APP", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});
    const [currentPremRatePayee, setCurrentPremRatePayee] = React.useState({premRate_Key: 0, payor_ID: "",
        account_Key: 0, amount_Pct: false, payee_ID: "", amount: 0, dist_Type: "PB", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""})

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialPremRateState = {
        premRate_Key: 0,
        premRate_ID: "",
        premRate_Category: "",
        premRate_Basis: "",
        description: "",
        effective_Date: "",
        term_Date: "",
        group_ID: "",
        division_ID: "",
        plan_ID: "",
        plan_Type: "",
        tier: "",
        premRatePayees: [],
        rate_Type: "",
        rate: 0,
        rate_Variable1: 0,
        rate_Variable2: 0,
        rate_Variable3: 0,
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
        premRate_Type: "APP",
    }

    const initialPremRatePayeeState = {
        premRate_Key: 0,
        payor_ID: "",
        account_Key: 0,
        amount_Pct: false,
        payee_ID: "",
        amount: 0,
        dist_Type: "PB",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: ""
    }

    const clearPremRate = () => {
        //console.log(currentPremRate);
        setCurrentPremRate({...initialPremRateState});
    }

    const clearPremRatePayee = () => {
        setCurrentPremRatePayee({...initialPremRatePayeeState});
    }

    const importPremRates = async (premRateArray : any[]) => {
        refreshToken();

        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'PremRate/putList',
                    premRateArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setIsLoading(false);
                    setSuccessAlert(true);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named Census
        if (!isEmpty(excelData) && excelData.Sheets.PremRates !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            setIsLoading(true);
            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.PremRates);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let premRateArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const premRateIndexCollection = {
                rateKeyIndex: rawCellArray.indexOf('RATE KEY') + 1,
                rateIDIndex: rawCellArray.indexOf('RATE ID') + 1,
                categoryIndex: rawCellArray.indexOf('CATEGORY') + 1,
                basisIndex: rawCellArray.indexOf('BASIS') + 1,
                descriptionIndex: rawCellArray.indexOf('DESCRIPTION') + 1,
                effectiveDateIndex: rawCellArray.indexOf('EFFECTIVE DATE') + 1,
                termDateIndex: rawCellArray.indexOf('TERM DATE') + 1,
                groupIndex: rawCellArray.indexOf('GROUP') + 1,
                divisionIndex: rawCellArray.indexOf('DIVISION') + 1,
                planIndex: rawCellArray.indexOf('PLAN') + 1,
                planTypeIndex: rawCellArray.indexOf('PLAN TYPE') + 1,
                tierIndex: rawCellArray.indexOf('TIER') + 1,
                rateTypeIndex: rawCellArray.indexOf('RATE TYPE') + 1,
                rateIndex: rawCellArray.indexOf('RATE') + 1,
                rateVar1Index: rawCellArray.indexOf('VAR 1') + 1,
                rateVar2Index: rawCellArray.indexOf('VAR 2') + 1,
                rateVar3Index: rawCellArray.indexOf('VAR 3') + 1,
                payorIndex: rawCellArray.indexOf('PAYOR') + 1,
                accountIndex: rawCellArray.indexOf('ACCOUNT') + 1,
                isPercentIndex: rawCellArray.indexOf('PERCENT(BOOL)') + 1,
                percentageIndex: rawCellArray.indexOf('PERCENTAGE') + 1,
                payeeIndex: rawCellArray.indexOf('PAYEE') + 1,
                amountIndex: rawCellArray.indexOf('AMOUNT') + 1,
                payee2Index: rawCellArray.indexOf('PAYEE 2') + 1,
                amount2Index: rawCellArray.indexOf('AMOUNT 2') + 1,
                payee3Index: rawCellArray.indexOf('PAYEE 3') + 1,
                amount3Index: rawCellArray.indexOf('AMOUNT 3') + 1,
                payee4Index: rawCellArray.indexOf('PAYEE 4') + 1,
                amount4Index: rawCellArray.indexOf('AMOUNT 4') + 1,
                payee5Index: rawCellArray.indexOf('PAYEE 5') + 1,
                amount5Index: rawCellArray.indexOf('AMOUNT 5') + 1,
                payee6Index: rawCellArray.indexOf('PAYEE 6') + 1,
                amount6Index: rawCellArray.indexOf('AMOUNT 6') + 1,
                payee7Index: rawCellArray.indexOf('PAYEE 7') + 1,
                amount7Index: rawCellArray.indexOf('AMOUNT 7') + 1,
                payee8Index: rawCellArray.indexOf('PAYEE 8') + 1,
                amount8Index: rawCellArray.indexOf('AMOUNT 8') + 1,
                payee9Index: rawCellArray.indexOf('PAYEE 9') + 1,
                amount9Index: rawCellArray.indexOf('AMOUNT 9') + 1,
                payee10Index: rawCellArray.indexOf('PAYEE 10') + 1,
                amount10Index: rawCellArray.indexOf('AMOUNT 10') + 1,
            }

            if(premRateIndexCollection.groupIndex > 0 && premRateIndexCollection.rateKeyIndex > 0 && premRateIndexCollection.rateIDIndex > 0 &&
                premRateIndexCollection.categoryIndex > 0 && premRateIndexCollection.basisIndex > 0 && premRateIndexCollection.descriptionIndex > 0 &&
                premRateIndexCollection.effectiveDateIndex > 0 && premRateIndexCollection.termDateIndex > 0 && premRateIndexCollection.divisionIndex > 0 &&
                premRateIndexCollection.planIndex > 0 && premRateIndexCollection.planTypeIndex > 0 && premRateIndexCollection.tierIndex > 0 &&
                premRateIndexCollection.rateTypeIndex > 0 && premRateIndexCollection.rateIndex > 0 && premRateIndexCollection.rateVar1Index > 0 &&
                premRateIndexCollection.rateVar2Index > 0 && premRateIndexCollection.rateVar3Index > 0 && premRateIndexCollection.payorIndex > 0 &&
                premRateIndexCollection.accountIndex > 0 && premRateIndexCollection.isPercentIndex > 0 && premRateIndexCollection.percentageIndex
                && premRateIndexCollection.payeeIndex && premRateIndexCollection.amountIndex) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new rate array we skip over the previous rates determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with premrate key
                    if (premRateIndexCollection.rateKeyIndex > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.rateKeyIndex)].toString().length > 0) {
                        currentPremRate.premRate_Key = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.rateKeyIndex)]);
                    }
                    else {
                        currentPremRate.premRate_Key = 0;
                    }

                    //Rate ID
                    if (premRateIndexCollection.rateIDIndex > 0) {
                        currentPremRate.premRate_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.rateIDIndex)].toString().toUpperCase();
                    }

                    //Category
                    if (premRateIndexCollection.categoryIndex > 0) {
                        currentPremRate.premRate_Category = rawCellArray[(rowMultiplier + premRateIndexCollection.categoryIndex)].toString().toUpperCase();
                    }

                    //Basis
                    if (premRateIndexCollection.basisIndex > 0) {
                        currentPremRate.premRate_Basis = rawCellArray[(rowMultiplier + premRateIndexCollection.basisIndex)].toString().toUpperCase();
                    }

                    //Description
                    if (premRateIndexCollection.descriptionIndex > 0) {
                        currentPremRate.description = rawCellArray[(rowMultiplier + premRateIndexCollection.descriptionIndex)].toString().toUpperCase();
                    }

                    //effective date
                    if (premRateIndexCollection.effectiveDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + premRateIndexCollection.effectiveDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentPremRate.effective_Date = date.toString().toUpperCase();
                    }

                    //term date
                    if (premRateIndexCollection.termDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + premRateIndexCollection.termDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentPremRate.term_Date = date.toString().toUpperCase();
                    }

                    //group
                    if (premRateIndexCollection.groupIndex > 0) {
                        currentPremRate.group_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.groupIndex)].toString().toUpperCase();
                    }

                    //division
                    if (premRateIndexCollection.divisionIndex > 0) {
                        currentPremRate.division_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.divisionIndex)].toString().toUpperCase();
                    }

                    //plan
                    if (premRateIndexCollection.planIndex > 0) {
                        currentPremRate.plan_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.planIndex)].toString().toUpperCase();
                    }

                    //plan type
                    if (premRateIndexCollection.planTypeIndex > 0) {
                        currentPremRate.plan_Type = rawCellArray[(rowMultiplier + premRateIndexCollection.planTypeIndex)].toString().toUpperCase();
                    }

                    //tier
                    if (premRateIndexCollection.tierIndex > 0) {
                        currentPremRate.tier = rawCellArray[(rowMultiplier + premRateIndexCollection.tierIndex)].toString().toUpperCase();
                    }

                    //rate type
                    if (premRateIndexCollection.rateTypeIndex > 0) {
                        currentPremRate.rate_Type = rawCellArray[(rowMultiplier + premRateIndexCollection.rateTypeIndex)].toString().toUpperCase();
                    }

                    //rate
                    if (premRateIndexCollection.rateIndex > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.rateIndex)].toString().length > 0) {
                        currentPremRate.rate = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.rateIndex)]);
                    }

                    //rate var 1
                    if (premRateIndexCollection.rateVar1Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar1Index)].toString().length > 0) {
                        currentPremRate.rate_Variable1 = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar1Index)]);
                    }

                    //rate var 2
                    if (premRateIndexCollection.rateVar2Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar2Index)].toString().length > 0) {
                        currentPremRate.rate_Variable2 = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar2Index)]);
                    }

                    //rate var 3
                    if (premRateIndexCollection.rateVar3Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar3Index)].toString().length > 0) {
                        currentPremRate.rate_Variable3 = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.rateVar3Index)]);
                    }

                    //payor
                    if (premRateIndexCollection.payorIndex > 0) {
                        currentPremRatePayee.payor_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payorIndex)].toString().toUpperCase();
                    }

                    //account
                    if (premRateIndexCollection.accountIndex > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.accountIndex)].toString().length > 0) {
                        currentPremRatePayee.account_Key = rawCellArray[(rowMultiplier + premRateIndexCollection.accountIndex)].toString().toUpperCase();
                    }

                    //percent
                    if (premRateIndexCollection.isPercentIndex > 0) {
                        if (rawCellArray[(rowMultiplier + premRateIndexCollection.isPercentIndex)].toString().toUpperCase() === "YES" ||
                            rawCellArray[(rowMultiplier + premRateIndexCollection.isPercentIndex)].toString().toUpperCase() === "Y" ||
                            rawCellArray[(rowMultiplier + premRateIndexCollection.isPercentIndex)].toString().toUpperCase() === "T" ||
                            rawCellArray[(rowMultiplier + premRateIndexCollection.isPercentIndex)].toString().toUpperCase() === "TRUE" ||
                            rawCellArray[(rowMultiplier + premRateIndexCollection.isPercentIndex)].toString().toUpperCase() === "ON") {
                            currentPremRatePayee.amount_Pct = true;
                        } else {
                            currentPremRatePayee.amount_Pct = false;
                        }
                    }

                    //percent amount
                    if (premRateIndexCollection.percentageIndex > 0 && currentPremRatePayee.amount_Pct) {
                        currentPremRatePayee.amount = rawCellArray[(rowMultiplier + premRateIndexCollection.percentageIndex)];
                    }

                    //payees and amounts
                    if (premRateIndexCollection.payeeIndex > 0) {
                        currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payeeIndex)].toString().toUpperCase();
                    }

                    currentPremRatePayee.vbasoftware_database = currentDB;

                    currentPremRatePayee.vbapi_Token = getWithExpiry('vbapi_Token');

                    currentPremRate.vbasoftware_database = currentDB;

                    currentPremRate.vbapi_Token = getWithExpiry('vbapi_Token');

                    if (currentPremRatePayee.amount_Pct) {
                        currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));

                        let objectCopy = {...currentPremRate};

                        objectCopy.premRatePayees = cloneDeep(objectCopy.premRatePayees);

                        premRateArray.push(objectCopy);

                        currentPremRate.premRate_Key = initialPremRateState.premRate_Key;
                        currentPremRate.premRate_ID = initialPremRateState.premRate_ID;
                        currentPremRate.premRate_Category = initialPremRateState.premRate_Category;
                        currentPremRate.premRate_Basis = initialPremRateState.premRate_Basis;
                        currentPremRate.description = initialPremRateState.description;
                        currentPremRate.effective_Date = initialPremRateState.effective_Date;
                        currentPremRate.term_Date = initialPremRateState.term_Date;
                        currentPremRate.group_ID = initialPremRateState.group_ID;
                        currentPremRate.division_ID = initialPremRateState.division_ID;
                        currentPremRate.plan_ID = initialPremRateState.plan_ID;
                        currentPremRate.plan_Type = initialPremRateState.plan_Type;
                        currentPremRate.tier = initialPremRateState.tier;
                        currentPremRate.premRatePayees = initialPremRateState.premRatePayees;
                        currentPremRate.rate_Type = initialPremRateState.rate_Type;
                        currentPremRate.rate = initialPremRateState.rate;
                        currentPremRate.rate_Variable1 = initialPremRateState.rate_Variable1;
                        currentPremRate.rate_Variable2 = initialPremRateState.rate_Variable2;
                        currentPremRate.rate_Variable3 = initialPremRateState.rate_Variable3;
                        currentPremRate.premRate_Type = initialPremRateState.premRate_Type;

                        clearPremRate();
                        clearPremRatePayee();
                        currentPremRate.premRatePayees = currentPremRate.premRatePayees.slice(0, 0);
                    } else {
                        if (premRateIndexCollection.amountIndex > 0) {
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amountIndex)]);
                        }

                        currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));

                        if (premRateIndexCollection.payee2Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee2Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee2Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount2Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee3Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee3Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee3Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount3Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee4Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee4Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee4Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount4Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee5Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee5Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee5Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount5Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee6Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee6Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee6Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount6Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee7Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee7Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee7Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount7Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee8Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee8Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee8Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount8Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee9Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee9Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee9Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount9Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        if (premRateIndexCollection.payee10Index > 0 && rawCellArray[(rowMultiplier + premRateIndexCollection.payee10Index)].toString().length > 0) {
                            currentPremRatePayee.payee_ID = rawCellArray[(rowMultiplier + premRateIndexCollection.payee10Index)].toString().toUpperCase();
                            currentPremRatePayee.amount = Number(rawCellArray[(rowMultiplier + premRateIndexCollection.amount10Index)]);
                            currentPremRate.premRatePayees.push(cloneDeep(currentPremRatePayee));
                        }

                        let objectCopy = {...currentPremRate};

                        objectCopy.premRatePayees = cloneDeep(objectCopy.premRatePayees);

                        premRateArray.push(objectCopy);

                        currentPremRate.premRate_Key = initialPremRateState.premRate_Key;
                        currentPremRate.premRate_ID = initialPremRateState.premRate_ID;
                        currentPremRate.premRate_Category = initialPremRateState.premRate_Category;
                        currentPremRate.premRate_Basis = initialPremRateState.premRate_Basis;
                        currentPremRate.description = initialPremRateState.description;
                        currentPremRate.effective_Date = initialPremRateState.effective_Date;
                        currentPremRate.term_Date = initialPremRateState.term_Date;
                        currentPremRate.group_ID = initialPremRateState.group_ID;
                        currentPremRate.division_ID = initialPremRateState.division_ID;
                        currentPremRate.plan_ID = initialPremRateState.plan_ID;
                        currentPremRate.plan_Type = initialPremRateState.plan_Type;
                        currentPremRate.tier = initialPremRateState.tier;
                        currentPremRate.premRatePayees = initialPremRateState.premRatePayees;
                        currentPremRate.rate_Type = initialPremRateState.rate_Type;
                        currentPremRate.rate = initialPremRateState.rate;
                        currentPremRate.rate_Variable1 = initialPremRateState.rate_Variable1;
                        currentPremRate.rate_Variable2 = initialPremRateState.rate_Variable2;
                        currentPremRate.rate_Variable3 = initialPremRateState.rate_Variable3;
                        currentPremRate.premRate_Type = initialPremRateState.premRate_Type;

                        clearPremRate();
                        clearPremRatePayee();
                        currentPremRate.premRatePayees = currentPremRate.premRatePayees.slice(0, 0);
                    }
                }

                if(premRateArray.length > 0) {
                    importPremRates(premRateArray);
                }

                excelData.Sheets.PremRates = undefined;
            }
            else {
                setValidationText("Prem Rate fields are required. See base import template.");
                setValidationError(true);
                setIsLoading(false);

                excelData.Sheets.PremRates = undefined;
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.PremRates = undefined;
    }
    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Prem Rate Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkPremRateImporter)

BulkPremRateImporter.propTypes = {
    excelData: PropTypes.object.isRequired
};